import React from 'react';

const ContactSection = () => {
  // Handle submission feedback (optional)
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   const form = e.target;

  //   fetch(form.action, {
  //     method: "POST",
  //     body: new FormData(form),
  //   }).then(response => {
  //     if (response.ok) {
  //       alert("✅ Form submitted successfully! We’ll get back to you soon.");
  //       form.reset();
  //     } else {
  //       alert("❌ There was an error submitting the form. Please try again.");
  //     }
  //   }).catch(() => {
  //     alert("❌ Network error. Please try again later.");
  //   });
  // };

  return (
    <>
      {/* Page Title Section */}
      <section className="page-title" style={{ backgroundImage: 'url(images/background/3.jpg)' }}>
        <div className="auto-container">
          <h1>Contact</h1>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-section pt_120 pb_90 centred">
        <div className="auto-container">
          <div className="sec-title mb_50">
            <h2>Contact Information</h2>
          </div>
          <div className="row clearfix">

            {/* Phone */}
            <div className="col-lg-4 col-md-6 col-sm-12 info-column text-center">
              <div className="info-block-one">
                <div className="inner-box">
                  <div className="icon-box"><i className="fas fa-phone-alt"></i></div>
                  <h3>Phone Number</h3>
                  <p><a className="text-white" href="tel:+919356411908">+91 9356411908</a></p>
                  <p><a className="text-white" href="tel:+918600135991">+91 8600135991</a></p>
                </div>
              </div>
            </div>

            {/* Email */}
            <div className="col-lg-4 col-md-6 col-sm-12 info-column text-center">
              <div className="info-block-one mb-4">
                <div className="inner-box">
                  <div className="icon-box"><i className="fas fa-envelope"></i></div>

                  <h3>Email Address</h3>

                  <h5>For Reservation</h5>
                  <p><a className="text-white" href="mailto:booking@etravo.in">booking@etravo.in</a></p>
                  <h5>For Enquiry</h5>
                  <p><a className="text-white" href="mailto:sales@etravo.in">sales@etravo.in</a></p>
                </div>
              </div>

              {/* <div className="info-block-one">
    <div className="inner-box">
      <div className="icon-box"><i className="fas fa-envelope"></i></div>
      <h5>For Enquiry</h5>
      <h3>Email Address</h3>
      <p><a className="text-white" href="mailto:sales@etravo.in">sales@etravo.in</a></p>
    </div>
  </div> */}
            </div>


            {/* Location */}
            <div className="col-lg-4 col-md-6 col-sm-12 info-column text-center">
              <div className="info-block-one">
                <div className="inner-box">
                  <div className="icon-box"><i className="fas fa-map-marker-alt"></i></div>
                  <h3>Our Location</h3>
                  <h4>eTravo</h4>
                  <p className="text-white">Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Map + Contact Form */}
      <div className="contact-section">
        <div className="auto-container">
          <div className="row clearfix">

            {/* Map Column */}
            <div className="map-column col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <section className="map-section">
                <div className="map-outer">
                  <div className="map-canvas" style={{ height: '510px', backgroundColor: '#eee' }}>

                    {/* <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2989.354490557331!2d73.92818777519268!3d18.56287608253894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDMzJzQ2LjQiTiA3M8KwNTUnNTAuOCJF!5e1!3m2!1sen!2sin!4v1748597552299!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}

<iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d2987.8544147354755!2d73.87804477519484!3d18.648302882470162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM4JzUzLjkiTiA3M8KwNTInNTAuMiJF!5e1!3m2!1sen!2sin!4v1760768966656!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>


                  </div>
                </div>
              </section>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ContactSection;
